import type { PropsWithChildren } from 'react';

import { TagLabel, type TagLabelProps } from '@frontend/components';

import { useSelectStyles } from '../SelectStylesContext';

export interface MultiValueLabelProps extends PropsWithChildren<unknown> {
  innerProps: TagLabelProps;
}

export const MultiValueLabel = ({
  children,
  innerProps,
}: MultiValueLabelProps) => {
  const styles = useSelectStyles();

  return (
    <TagLabel {...innerProps} __css={styles.multiValueLabel}>
      {children}
    </TagLabel>
  );
};
